import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { OwnerDetailActions, OwnerDetailModuleState } from '~/store/owner/detail'

export default defineComponent({
  name: 'OwnerDetailMixin',

  computed: {
    ...(mapState<OwnerDetailModuleState>('owner/detail', {
      owner: (state: OwnerDetailModuleState) => state.owner,
      ownerStoreLoading: (state: OwnerDetailModuleState) => state.loading,
      ownerStoreError: (state: OwnerDetailModuleState) => state.error
    }) as {
      owner: () => OwnerDetailModuleState['owner']
      ownerStoreLoading: () => OwnerDetailModuleState['loading']
      ownerStoreError: () => OwnerDetailModuleState['error']
    })
  },

  methods: {
    ...mapActions('owner/detail', {
      fetchOwnerID: OwnerDetailActions.FETCH_OWNER_ID,
      fetchOwnerDetails: OwnerDetailActions.FETCH_OWNER_DETAILS,
      fetchGeneralData: OwnerDetailActions.FETCH_GENERAL_DATA,
      fetchIssueTypeSettings: OwnerDetailActions.FETCH_ISSUE_TYPE_SETTINGS,
      fetchAccountSetupStatus: OwnerDetailActions.FETCH_ACCOUNT_SETUP_STATUS,
      fetchAppConfig: OwnerDetailActions.FETCH_APP_CONFIG,
      submitIssueTypeSettings: OwnerDetailActions.SUBMIT_ISSUE_TYPE_SETTINGS,
      syncReposForOwner: OwnerDetailActions.SYNC_REPOS_FOR_OWNER,
      syncSingleRepoForOwner: OwnerDetailActions.SYNC_SINGLE_REPO_FOR_OWNER,
      fetchOwnerSSHKey: OwnerDetailActions.FETCH_OWNER_SSH_KEY,
      generateOwnerSSHKey: OwnerDetailActions.GENERATE_OWNER_SSH_KEY,
      removeOwnerSSHKey: OwnerDetailActions.REMOVE_OWNER_SSH_KEY,
      fetchUsageDetails: OwnerDetailActions.FETCH_USAGE_DETAILS,
      fetchMaxUsagePercentage: OwnerDetailActions.FETCH_MAX_USAGE_PERCENTAGE,
      fetchIntegrationForFeature: OwnerDetailActions.FETCH_INTEGRATIONS_FOR_FEATURE,
      fetchShouldTimeoutDataTrigger: OwnerDetailActions.FETCH_SHOULD_TIMEOUT_DATA_TRIGGER,
      fetchLegacySecretAnalyzerPreference: OwnerDetailActions.FETCH_LEGACY_SECRET_ANALYZER,
      fetchShouldCommitConfigPreference: OwnerDetailActions.FETCH_SHOULD_COMMIT_CONFIG,
      setDataTimeoutTrigger: OwnerDetailActions.SET_DATA_TIMEOUT_TRIGGER,
      setLegacySecretAnalyzerPreference: OwnerDetailActions.SET_LEGACY_SECRET_ANALYZER,
      deleteTeam: OwnerDetailActions.DELETE_TEAM,
      updateOwnerSettings: OwnerDetailActions.UPDATE_OWNER_SETTINGS
    })
  }
})
